module.exports = __webpack_public_path__ + "img/writing.b63b0dc5.svg";